import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalSearchModel} from '../models/search/global-search.model';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  constructor(private http: HttpClient) { }

  globalSearch(str: string) {
    return this.http.post<GlobalSearchModel>(`api/search`, {searchText: str});
  }
}
